import { SecurityEventRes } from '@dealstack/shared/lib/generated';
import React, { useContext } from 'react';
import { Button, Flex } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { SecurityEvents } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityEventsTable/SecurityEvents.tsx';
import { useSecurityEventsTableController } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityEventsTable/useSecurityEventsTableController.ts';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { CreateSecurityEventDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityEventDrawer/CreateSecurityEventDrawer.tsx';
import { EditSecurityEventDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityEventDrawer/EditSecurityEventDrawer.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { SecurityDetailsControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/useSecurityDetailsController.ts';

interface Props {
	hasEditorPermission?: boolean;
}

export const SecurityEventsTabPanel = ({ hasEditorPermission }: Props) => {
	const tCapManage = useTranslationCapManage();

	const { refetchSecurityDetails } = useContext(SecurityDetailsControllerContext);
	const {
		showCreateSecurityEventDrawer,
		setShowCreateSecurityEventDrawer,
		onSecurityCreateEventModalClose,
		getSecurityEventRequest,
		showEditSecurityEventDrawer,
		setShowEditSecurityEventDrawer,
		securityEventEdit,
		setSecurityEventEdit,
		tableRef,
		mantineTableDataOperations,
		eventColumns,
		isTableLoading,
		securityId,
		personId,
		refetchEvents,
	} = useSecurityEventsTableController(hasEditorPermission);

	return (
		<>
			{hasEditorPermission && (
				<Flex p="xs" justify="flex-end">
					<Button
						data-testid={TEST_ELEMENT_IDS.CAP_NEW_EVENT_BUTTON}
						leftSection={<Icon variant="plus" size="lg" />}
						onClick={() => {
							setShowCreateSecurityEventDrawer(true);
						}}
					>
						{tCapManage('securities.details.security_new_event')}
					</Button>
				</Flex>
			)}
			<Flex direction="column" p="xs">
				<SecurityEvents
					eventColumns={eventColumns}
					securityEvents={getSecurityEventRequest?.data}
					isTableLoading={isTableLoading}
					mantineTableDataOperations={mantineTableDataOperations}
					tableRef={tableRef}
				/>
			</Flex>
			<CreateSecurityEventDrawer
				securityId={securityId}
				entityId={personId}
				opened={showCreateSecurityEventDrawer}
				onClose={onSecurityCreateEventModalClose}
				refreshSecuritiesList={refetchEvents}
				refreshSecurityNominalValue={() => securityId && refetchSecurityDetails(securityId)}
			/>
			<EditSecurityEventDrawer
				securityId={securityId}
				entityId={personId}
				opened={showEditSecurityEventDrawer}
				onClose={() => {
					setSecurityEventEdit(undefined);
					setShowEditSecurityEventDrawer(false);
				}}
				refreshSecuritiesList={refetchEvents}
				refreshSecurityNominalValue={() => securityId && refetchSecurityDetails(securityId)}
				securityEvent={securityEventEdit ?? ({} as SecurityEventRes)}
			/>
		</>
	);
};
